import React from 'react';
import { AuthProvider } from './contexts/AuthContext';
import { ChatProvider } from './contexts/ChatContext';
import AstroCampaignApp from './components/AstroCampaignApp';
import './App.css';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ChatProvider>
          <AstroCampaignApp />
        </ChatProvider>
      </AuthProvider>
    </div>
  );
}

export default App;